import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bell } from 'lucide-react';
const names = ['Martín', 'Lucas', 'Facundo', 'Diego', 'Ezequiel', 'Tomás', 'Gonzalo', 'Agustín', 'Joaquín', 'Federico', 'Juan', 'Maxi', 'Alejandro', 'Pablo', 'Rodrigo'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'San Juan', 'Resistencia', 'Posadas', 'San Luis', 'Bahía Blanca'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showPopup();
      // Then set interval between 8-10 seconds
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 2000) + 8000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-234">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-zinc-900 border border-zinc-800 shadow-2xl rounded-lg p-4 max-w-sm flex items-start gap-3" data-id="element-235">
          <div className="bg-amber-500/20 p-2 rounded-full text-amber-500 shrink-0 mt-0.5" data-id="element-236">
            <Bell className="w-4 h-4" data-id="element-237" />
          </div>
          <div data-id="element-238">
            <p className="text-sm text-zinc-300" data-id="element-239">
              <span className="font-bold text-white" data-id="element-240">{currentData.name}</span>{' '}
              de {currentData.city} acaba de adquirir el plan
            </p>
            <p className="text-xs text-zinc-500 mt-1" data-id="element-241">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}